import cuid from 'cuid';

const TAB_ID_KEY = 'tid';
const LAST_VENUE_ID_KEY = 'lvid';

const init = () => {
  const id = cuid();

  sessionStorage.setItem(TAB_ID_KEY, id);
};

const getTabId = path => sessionStorage.getItem(TAB_ID_KEY);
const setLastVenueId = id => localStorage.setItem(LAST_VENUE_ID_KEY, id);

export { init, getTabId, setLastVenueId };



// WEBPACK FOOTER //
// ./src/lib/tabManager.js